import React, { useEffect, useRef } from 'react';
import {
  useDataProvider,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';
import { useForm, useFormState } from 'react-final-form';
import moment from 'moment';

const ImportCleanerInput = () => {
  const dataProvider = useDataProvider();
  const form = useForm();
  const { values } = useFormState({ subscription: { values: true } });
  const selectedId = values.import_cleaner_id;
  const lastId = useRef(null);

  useEffect(() => {
    const fetchAndPopulate = async () => {
      if (selectedId && selectedId !== lastId.current) {
        lastId.current = selectedId;
        try {
          const { data } = await dataProvider.getOne('cleaner', {
            id: selectedId,
          });
          if (data) {
            const fieldsToCopy = [
              'salutation',
              'firstname',
              'lastname',
              'function',
              'email',
              'mobile_phone',
              'phone',
              'mailing_street',
              'mailing_additional',
              'mailing_postal_code',
              'mailing_city',
              'quartier_prioritaire_de_la_ville',
              'birthdate',
              'birthplace',
              'nationality',
              'social_security_number',
              'residence_permit_number',
              'residence_permit_expiry_date',
              'residence_permit_nature',
              'payfit_id',
              'silae_id', // kept: legitimate "same matricule, new fiche" flow
              'drive_folder_id',
              // 'employee_status' removed (plan 036, frontière vivier): importing
              // it here let the vivier status leak into a freshly created
              // Cleaner fiche instead of going through Profil vivier.
              'health_insurance_exemption',
              'health_insurance_exemption_reason',
              'health_insurance_exemption_end_date',
              'health_insurance_exemption_file',
              'occupational_medecine_reason',
              'occupational_medecine_date',
              'occupational_medecine_file',
              'spvie_id',
              'is_taken_over',
              'cdd_etudiant',
              'contract_start_date',
              'seniority_date',
              'trial_period_renewal_signing',
              'contract_end_date',
              'contract_end_type',
              'contract_end_reason',
              'metadata',
            ];

            form.batch(() => {
              fieldsToCopy.forEach((field) => {
                if (data[field] !== undefined) {
                  form.change(field, data[field]);
                }
              });
            });
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error("Erreur lors de l'import du cleaner", error);
        }
      } else if (!selectedId) {
        lastId.current = null;
      }
    };

    fetchAndPopulate();
  }, [selectedId, dataProvider, form]);

  return (
    <ReferenceInput
      label="Importer depuis un autre cleaner"
      source="import_cleaner_id"
      reference="cleaner"
      allowEmpty
      fullWidth
      perPage={50}
      sort={{ field: 'contract_end_date', order: 'DESC' }}
      filterToQuery={(searchText) => {
        return { fullname: searchText };
      }}
    >
      <AutocompleteInput
        optionText={(record) => {
          if (record && record.contract_end_date) {
            return `${record.fullname} - ${moment(
              record.contract_end_date,
            ).format('DD/MM/YY')}`;
          }
          return record ? record.fullname || '' : '';
        }}
        fullWidth
      />
    </ReferenceInput>
  );
};

export default ImportCleanerInput;
